import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var OrganizationPaymentApi = /** @class */ (function () {
    function OrganizationPaymentApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    OrganizationPaymentApi.initialize = function (basePath, fetchApi) {
        if (!OrganizationPaymentApi.instance) {
            OrganizationPaymentApi.instance = new OrganizationPaymentApi(basePath, fetchApi);
        }
        return OrganizationPaymentApi.instance;
    };
    OrganizationPaymentApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1OrganizationPaymentApi(new Configuration(config));
    };
    return OrganizationPaymentApi;
}());
export { OrganizationPaymentApi };
